<!--
 * @Description: 开票维护-开票信息
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    :model="formData"
    :rules="formRules"
  >
    <div class="form-dialog__title" style="margin-top: 0">
      <h1>开票信息</h1>
      <BaseButton size="small" :click="onSave">
        {{ disabled ? '编辑' : '保存' }}
      </BaseButton>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="企业名称" prop="entpName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          v-model="formData.entpName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="纳税识别号" prop="entpCertNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :disabled="disabled"
          v-model="formData.entpCertNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="phone">
        <BaseInput
          class="form-dialog__w280"
          type="tel"
          placeholder="请输入"
          :disabled="disabled"
          v-model="formData.phone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="开户银行" prop="bankName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :disabled="disabled"
          v-model="formData.bankName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="银行账号" prop="openBankNumber">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :disabled="disabled"
          v-model="formData.openBankNumber"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="企业地址" prop="companyBusinessAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :disabled="disabled"
          v-model="formData.companyBusinessAddress"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="开票备注" prop="demand">
        <BaseInput
          class="form-dialog__w280"
          type="textarea"
          placeholder="请输入"
          show-word-limit
          :disabled="disabled"
          :rows="4"
          :maxlength="200"
          v-model="formData.demand"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { withDefaults, defineProps, ref, watchEffect } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseButton } from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import { invoiceInformationEditing } from '@V/invoice/src/data-source/apis';

type BaseInfo = BasicInformationData['baseInfo'];

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    value: BaseInfo;
  }>(),
  {
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const formRef = ref(null);
const formData = ref<BaseInfo>(props.value);
const disabled = ref(true); // false可编辑并按钮变为保存

const formRules = {
  entpName: [{ required: true, message: '请输入', trigger: 'blur' }],
  entpCertNo: [{ required: true, message: '请输入', trigger: 'blur' }],
  phone: [{ required: true, message: '请输入', trigger: 'blur' }],
  bankName: [{ required: true, message: '请输入', trigger: 'blur' }],
  openBankNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
  companyBusinessAddress: [
    { required: true, message: '请输入', trigger: 'blur' }
  ]
};

watchEffect(() => {
  formData.value = props.value;
});

const onSave = async () => {
  // 保存
  if (!disabled.value) {
    await formRef.value.validate();
    await invoiceInformationEditing(formData.value);
  }
  disabled.value = !disabled.value;
};
</script>
